export default __webpack_public_path__ + "static/media/hero.596bce55.jpg";